import {json} from '../core/data-source/json.mapper';
import {LatLon} from './lat-lon.interface';

let uid = 0;
export class AddressRecord implements LatLon {
    @json() id: number;

    @json({
        mapper: {
            from: (data: any, record: any): string => record.address || record.name
        }
    })
    address: string;

    @json()
    postcode: string;

    @json() name: string;

    @json() locationName: string;

    @json()
    latitude: number;

    @json()
    longitude: number;

    @json() corrected: boolean;

    @json() isCustomerLocation: boolean;

    @json()
    w3wAddress: string;

    @json({
        skip: true,
        mapper: {
            from: (data: any, record: any): boolean => {
                return !record.address && !record.name && !record.latitude && !record.longitude;
            }
        }
    })
    isEmpty: boolean;

    key: number = ++uid;
}
